module.exports = __webpack_public_path__ + "img/tyh1.996d333c.jpg";